import { gql } from "@apollo/client";

export const GetCaseStudies = gql`
  query GetCaseStudies(
    $token: String!
    $after: Cursor
    $first: Int
    $startDate: Time
    $endDate: Time
    $customerID: ID!
    $caseType: String
    $orderBy: CaseStudiesOrder
    $name: String
  ) {
    GetCaseStudies(
      token: $token
      customerID: $customerID
      after: $after
      first: $first
      startDate: $startDate
      endDate: $endDate
      orderBy: $orderBy
      caseType:$caseType
      where: { or: [{ titleContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          title
          startDate
          endDate
          synopsis
          documents
          caseType
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const getCaseStudyByNodeId = gql`
  query getCaseStudyByNodeId($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      id
      ... on CaseStudies {
        title
        startDate
        endDate
        synopsis
        documents
        caseType
      }
    }
  }
`;
export const GetCaseTypes = gql`
  query GetCaseTypes($token: String!, $customerID: ID!) {
    GetCaseTypes(token: $token, customerID: $customerID)
  }
`;
